module.exports = __webpack_public_path__ + "static/media/slider4.ed6f84db.webp";